import {addCssToHead} from "../../../../helpers/CssHelpers";

export const CHAT_SENDER_COLORS = [
    "#f08a5d", "#b83b5e", "#6a2c70", "#3b6978", "#204051",
    "#84a9ac", "#f76c6c", "#99b898", "#feceab", "#ff847c",
    "#e84a5f", "#2a363b", "#ffb347", "#ffa07a", "#f7cac9",
    "#92a8d1", "#d5a6bd", "#c94c4c", "#77c9d4", "#57bc90"
];

addCssToHead(CHAT_SENDER_COLORS.map((c, i) => `.chat-sender-color-${i}{color:${c}!important;}`).join('\n'));
export function getSenderClassNameForUserId(id) {
    return 'chat-sender-color-' + getSenderColorIndexForUserId(id);
}

export function getSenderColorIndexForUserId(id) {
    function hashStringToNumber(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
            hash = hash & hash; // Converte in 32bit integer
        }
        return Math.abs(hash);
    }

    const hash = hashStringToNumber(id.toString());
    return hash % CHAT_SENDER_COLORS.length;
}
